module.exports = __webpack_public_path__ + "img/00ca28e3[1](1).6700ff2e.png";